<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.97414 16.642L6.91064 15.5785L10.6836 11.8055L6.91064 8.05752L7.97414 6.99402L11.7471 10.767L15.4951 6.99402L16.5586 8.05752L12.7856 11.8055L16.5586 15.5785L15.4951 16.642L11.7471 12.869L7.97414 16.642Z" fill="currentColor"/>
</svg>
